import { useState } from "react";
import { getInitialDataAnnouncements } from "../controllers/announcements";
import { Announcement, Query, Result } from "../interfaces";
import { Adapter } from "../shared/adapter";
import { useSelector } from "react-redux";
import { AnnouncementsAdapter } from "../adapter/announcements -adapter";

const initialState: Result<Announcement> = {
  loading: false,
  values: [],
};

export default function useAnnouncementsSearch() {
  const [result, setResult] = useState<Result<Announcement>>(initialState);
  const userState = useSelector((state: any) => state.user.user);

  const searchAnnouncements = async (
    collection: string,
    query: Query,
    page?: number,
    limit?: number
  ) => {
    try {
      setResult((prevResult) => ({ ...prevResult, loading: true }));
      const response = await getInitialDataAnnouncements(
        collection || "all",
        query,
        page,
        limit,
        userState?.me
      );

      try {
        Adapter.from(response.items).to((value) =>
          new AnnouncementsAdapter(value).adapt()
        );
      } catch (error) {
        console.log("error en el adaptador EventsAdapter", error);
      }
      setResult({
        values: Adapter.from(response.items).to((value) =>
          new AnnouncementsAdapter(value).adapt()
        ),
        loading: false,
        pagination: {
          limit,
          page,
          total: response.meta.total,
        },
      });
    } catch (error) {
      console.log("error", error);
      setResult((prevResult) => ({ ...prevResult, loading: false }));
    }
  };

  return {
    result,
    searchAnnouncements,
  };
}
